export default "__VITE_PUBLIC_ASSET__86483de0__"